import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import {
  compatWrapper,
  convertLegacyPlugin,
} from '@backstage/core-compat-api';
import {
  isJfrogArtifactoryAvailable,
  jfrogArtifactoryPlugin as legacyJfrogArtifactoryPlugin,
} from '@backstage-community/plugin-jfrog-artifactory';

const jfrogArtifactoryTab = EntityContentBlueprint.make({
  name: 'jfrog-artifactory',
  params: {
    path: '/jfrog-artifactory',
    title: 'JFrog Artifactory',
    // Only show the tab for entities annotated with a JFrog image name.
    filter: isJfrogArtifactoryAvailable,
    loader: async () => {
      const { JfrogArtifactoryPage } = await import(
        '@backstage-community/plugin-jfrog-artifactory'
      );
      // Plugin page is legacy-frontend; wrap so legacy APIs resolve.
      return compatWrapper(<JfrogArtifactoryPage />);
    },
  },
});

// Convert the whole legacy plugin (not just the page) so its API factory —
// jfrogArtifactoryApiRef (`plugin.jfrog-artifactory.service`) — is registered
// in the new frontend system. compatWrapper alone renders the page but does
// not bring the plugin's apis, which the page needs at runtime.
export const jfrogArtifactoryPlugin = convertLegacyPlugin(
  legacyJfrogArtifactoryPlugin,
  {
    extensions: [jfrogArtifactoryTab],
  },
);